import React from 'react';
import type { SvgProps } from 'react-native-svg';
import Svg, { ClipPath, Defs, G, Path, Rect } from 'react-native-svg';

export interface GoogleSimpleIconProps extends SvgProps {
  size?: number;
  color: string; // Required - caller must pass semantic token color
}

export const GoogleSimpleIcon: React.FC<GoogleSimpleIconProps> = ({
  size = 14,
  color,
  ...props
}) => {
  return (
    <Svg width={size} height={size} viewBox="0 0 14 14" fill="none" {...props}>
      <G clipPath="url(#clip0_204_38231)">
        <Path
          d="M13.9918 7.13077C13.9918 6.5572 13.9442 6.13864 13.8411 5.70459H7.13867V8.29341H11.0729C10.9936 8.93677 10.5653 9.90566 9.61341 10.5567L9.60007 10.6434L11.7193 12.2477L11.8661 12.262C13.2145 11.0451 13.9918 9.25455 13.9918 7.13077Z"
          fill={color}
        />
        <Path
          d="M7.13901 13.9518C9.06644 13.9518 10.6845 13.3316 11.8664 12.262L9.61376 10.5567C9.01094 10.9676 8.20186 11.2543 7.13901 11.2543C5.25122 11.2543 3.64898 10.0375 3.07783 8.35547L2.99411 8.36242L0.790536 10.0289L0.761719 10.1072C1.93563 12.386 4.34695 13.9518 7.13901 13.9518Z"
          fill={color}
        />
        <Path
          d="M3.07755 8.35563C2.92685 7.92158 2.83963 7.45648 2.83963 6.97594C2.83963 6.49534 2.92685 6.0303 3.06962 5.59624L3.06563 5.5038L0.834445 3.81055L0.761445 3.84448C0.27762 4.79012 0 5.85204 0 6.97594C0 8.09984 0.27762 9.1617 0.761445 10.1073L3.07755 8.35563Z"
          fill={color}
        />
        <Path
          d="M7.13899 2.69735C8.47946 2.69735 9.38368 3.26318 9.89928 3.73602L11.914 1.81375C10.6766 0.689847 9.06642 0 7.13899 0C4.34693 0 1.93563 1.5657 0.761719 3.8445L3.06989 5.59626C3.64898 3.91428 5.25121 2.69735 7.13899 2.69735Z"
          fill={color}
        />
      </G>
      <Defs>
        <ClipPath id="clip0_204_38231">
          <Rect width="14" height="14" fill="white" />
        </ClipPath>
      </Defs>
    </Svg>
  );
};

GoogleSimpleIcon.displayName = 'GoogleSimpleIcon';
